import Link from 'next/link';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { PAGES } from '@/constants/pages';
import { useAppSelector } from '@/redux';
import { removeEndSlash } from '@/utils/millesimaUtils';
import styles from './NavBarHomeLink.module.scss';

export const NavBarHomeLink = ({ logo, mobile, expanded, checkout, backgroundColor, isBlog }) => {
	const storeConf = useAppSelector(({ root }) => root.storeConf);
	const className = useMemo(
		() =>
			[
				`${styles['millesima-logo']} tu-link`,
				checkout && styles['checkout'],
				mobile ? styles['mobile'] : 'desktop',
				expanded && styles['navbar-expanded'],
				backgroundColor && styles[`millesima-logo-${backgroundColor}`],
			]
				.filter(Boolean)
				.join(' '),
		[checkout, mobile, expanded, backgroundColor],
	);

	const headerStyle = {
		backgroundColor: storeConf.headerBackgroundColor || checkout ? '#151515' : 'transparent',
		color: storeConf.headerFontColor || '#e5e5e5',
	};

	const navigation = () => {
		if (isBlog) {
			return PAGES.BLOG;
		}
		return removeEndSlash(storeConf.url);
	};

	return (
		<Link href={navigation()} passHref className={className} style={headerStyle} aria-label="logo" id="ti-millesima-logo">
			<img
				className="tu-image"
				src={logo}
				width={storeConf.logoWidth || 175}
				height={storeConf.logoHeight || 40}
				alt="Millesima logo"
			/>
		</Link>
	);
};

NavBarHomeLink.propTypes = {
	logo: PropTypes.string.isRequired,
	checkout: PropTypes.bool,
	mobile: PropTypes.bool,
	expanded: PropTypes.bool,
	backgroundColor: PropTypes.string,
	storeConf: PropTypes.object,
	isBlog: PropTypes.bool,
};

export default React.memo(NavBarHomeLink);
